import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=84761f5c&"
import script from "./Battle.vue?vue&type=script&lang=js&"
export * from "./Battle.vue?vue&type=script&lang=js&"
import style0 from "./Battle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports